// Lichtgewicht CSS-staafgrafiek (geen dependency). months: [{ label, values:[..] }]; series: [{ label, color }].
export default function MiniBarChart({ months = [], series = [], fmt = (v) => v, stacked = false, height = 150 }) {
  const max = Math.max(1, ...months.map((m) => (stacked ? (m.values || []).reduce((s, v) => s + v, 0) : Math.max(0, ...(m.values || [])))));
  return (
    <div>
      <div className="flex items-end gap-1 sm:gap-2" style={{ height: height + 24 }}>
        {months.map((m, i) => (
          <div key={i} className="flex-1 flex flex-col items-center justify-end gap-1 h-full">
            {stacked ? (
              <div className="flex flex-col-reverse w-2.5 sm:w-4 overflow-hidden rounded-t" style={{ height }}>
                {(m.values || []).map((v, si) => <div key={si} title={`${series[si]?.label}: ${fmt(v)}`} style={{ height: `${(v / max) * height}px`, background: series[si]?.color }}></div>)}
              </div>
            ) : (
              <div className="flex items-end justify-center gap-0.5 w-full" style={{ height }}>
                {(m.values || []).map((v, si) => <div key={si} title={`${series[si]?.label}: ${fmt(v)}`} className="w-2 sm:w-3 rounded-t" style={{ height: `${(v / max) * height}px`, background: series[si]?.color }}></div>)}
              </div>
            )}
            <span className="text-[10px] text-slate-400">{m.label}</span>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap gap-4 mt-2 text-xs text-slate-500">{series.map((s, i) => <span key={i} className="inline-flex items-center gap-1"><span className="h-2.5 w-2.5 rounded-sm" style={{ background: s.color }}></span>{s.label}</span>)}</div>
    </div>
  );
}
